import { PieChart } from "lucide-react";
import { Card } from "@/components/ui/card";

const brl = (v) =>
  (v ?? 0).toLocaleString("pt-BR", {
    style: "currency", currency: "BRL", maximumFractionDigits: 0,
  });

const PALETTE = [
  "bg-indigo-500", "bg-emerald-500", "bg-amber-500",
  "bg-rose-500", "bg-cyan-500", "bg-violet-500",
  "bg-orange-500", "bg-teal-500",
];

/**
 * CategoryBreakdownCard — distribuição de gastos por categoria do mês.
 * Renderiza payload de backend build_category_breakdown.
 */
export default function CategoryBreakdownCard({ data }) {
  const total = data?.total ?? 0;
  const categories = data?.categories || [];

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs text-foreground-muted">
          Gastos por categoria · {data?.month || ""}
        </div>
        <div className="text-xs font-semibold text-foreground">{brl(total)}</div>
      </div>

      {/* Barra empilhada de proporções */}
      {total > 0 && categories.length > 0 && (
        <div className="flex h-2 rounded-full overflow-hidden bg-surface-card-hover mb-3">
          {categories.slice(0, 8).map((c, i) => (
            <div
              key={c.name}
              className={`${PALETTE[i % PALETTE.length]}`}
              style={{ width: `${c.pct}%` }}
              title={`${c.name}: ${c.pct}%`}
            />
          ))}
        </div>
      )}

      {/* Lista detalhada */}
      {categories.length === 0 ? (
        <div className="flex items-center gap-2 text-xs text-foreground-muted py-3">
          <PieChart className="w-4 h-4" />
          Sem gastos registrados no mês.
        </div>
      ) : (
        <div className="space-y-1">
          {categories.slice(0, 8).map((c, i) => (
            <div
              key={c.name}
              className="flex items-center justify-between py-1.5 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="flex items-center gap-2 min-w-0 mr-2">
                <span className={`w-2 h-2 rounded-full ${PALETTE[i % PALETTE.length]}`} />
                <span className="text-xs text-foreground capitalize truncate">
                  {c.name}
                </span>
              </div>
              <div className="text-[10px] text-foreground-muted whitespace-nowrap">
                {brl(c.value)} <span className="opacity-60">({c.pct}%)</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
